import { Lightning, Router } from '@lightningjs/sdk'

import ListMenu from '../../components/SettingsMenu/SettingsMenu'
import { transparent } from '../../constants/colors'
import { LEFT_SAFE_ZONE_MARGIN } from '../../constants/general'
import { Images } from '../../constants/paths'
import { getAsset } from '../../utils/image'
import { captureScreenData, NON_BFF_SEGMENT_SCREENS } from '../../utils/segmentAnalytics'
import PageHandler from '../handlers/pageHandler'

export default class Settings extends PageHandler {
  private _lastSectionSelected = 0

  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: transparent,
      collision: true,
      flex: {
        direction: 'row',
        paddingLeft: LEFT_SAFE_ZONE_MARGIN,
      },
      LeftContainer: {
        w: 872,
        h: 1080,
        rect: true,
        color: transparent,
        Logo: {
          x: (w) => w / 2,
          y: (h) => h / 2,
          mount: 0.5,
          texture: Lightning.Tools.getSvgTexture(getAsset(Images.LOGO_FADED), 375, 361),
        },
      },
      RightContainer: {
        w: 808,
        h: 1080,
        rect: true,
        color: transparent,
        ListMenu: {
          y: 80,
          type: ListMenu,
        },
      },
    }
  }

  get pageText() {
    return 'Settings'
  }

  get listMenu() {
    return this.tag('ListMenu') as ListMenu
  }

  get currentTab() {
    return this.listMenu.currentChild
  }

  static _states() {
    return [
      class NotReady extends this {
        _handleKey() {
          return true
        }
      },
      class Ready extends this {
        $enter() {
          this.listMenu.currentEl = this._lastSectionSelected

          Router.focusPage()
        }

        _getFocused() {
          return this.listMenu
        }
      },
      class InBackgroundByModal extends this {
        _handleKey() {
          this.focusActiveModal()
        }
      },
    ]
  }

  _init() {
    this._isRoot = true

    this._setState('NotReady')
  }

  _active() {
    this._setState('Ready')
    void captureScreenData(NON_BFF_SEGMENT_SCREENS.Settings)
  }

  _handleLeft() {
    Router.focusWidget('Menu')
  }

  historyState(params) {
    if (params) {
      this._lastSectionSelected = params.lastSectionSelected
    } else {
      return {
        lastSectionSelected: this.listMenu.currentEl,
      }
    }
  }

  _onCursorLeave() {
    this.listMenu?.currentChild?._focus()
  }
}
